import { useEffect } from 'react';
import useFetch from '../../api/useFetch';
import { Box, Button, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

export const NewGoogleEmailIntegration = ({ onClose }) => {
  const { t } = useTranslation();

  const { apiData } = useFetch('gmail/auth-url');

  const url = apiData?.data?.authUrl;

  useEffect(() => {
    if (!url) return;
    window.location.assign(url);
    //onClose();
  }, [url]);

  function handleRefresh() {
    window.location.reload();
    onClose(); //Not really needed but here just in case
  }

  return (
    <Box className="flex flex-col justify-center items-center w-full h-full gap-5">
      <Typography fontSize={18} className="text-center">
        {t(
          'Please follow the intructions from Google and afterwards return to the inbox'
        )}
      </Typography>
      <Button onClick={() => handleRefresh()} variant="contained" color="info">
        {t('To the inbox')}
      </Button>
    </Box>
  );
};
